<template>
    <ul class="profile-certifications__list">
        <CertificationFragment
            v-for="element in certificationSectionState"
            :key="`certification--${element.index}`"
            :model-value="element"
            :is-sample="false"
            :is-edit-mode="false"
        />
    </ul>
</template>

<script setup lang="ts">
    import CertificationFragment from '~/components/main/certifications/CertificationFragment.vue';
    import {useCertificationSectionState} from '~/features/certifications/composables/useCertificationSectionState';

    // State
    const certificationSectionState = useCertificationSectionState();
</script>
